/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_api as api,
} from "../../runtime/index.jsx";
export function VincularPorTelefono(e) {
  let t = (0, ReactCompiler.c)(24),
    { bot: n, onCambio: r } = e,
    i = Go(),
    [a, o] = (0, React.useState)(!1),
    [s, c] = (0, React.useState)(``),
    l;
  t[0] !== i || t[1] !== n.id || t[2] !== s || t[3] !== r
    ? ((l = async function () {
        try {
          (await api(`/bots/${n.id}/codigo`, {
            method: `POST`,
            body: {
              telefono: s,
            },
          }),
            i.ok(`En unos segundos aparece el código`),
            o(!1),
            await r());
        } catch (e) {
          let t = e;
          i.error(t.message);
        }
      }),
      (t[0] = i),
      (t[1] = n.id),
      (t[2] = s),
      (t[3] = r),
      (t[4] = l))
    : (l = t[4]);
  let u = l;
  if (n.codigoPendiente) {
    let e;
    return (
      t[5] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((e = (
            <p
              className={`text-xs text-(--text)`}
              children={`Pidiendo el código a WhatsApp…`}
            />
          )),
          (t[5] = e))
        : (e = t[5]),
      e
    );
  }
  if (!a) {
    let e;
    t[6] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((e = () => o(!0)), (t[6] = e))
      : (e = t[6]);
    let r = n.codigo
        ? `Pedir el código para otro número`
        : `¿No lee el QR? Vincular con el número de teléfono`,
      i;
    return (
      t[7] === r
        ? (i = t[8])
        : ((i = (
            <button
              type={`button`}
              className={`self-start text-xs text-(--accent-texto) underline-offset-2 hover:underline`}
              onClick={e}
              children={r}
            />
          )),
          (t[7] = r),
          (t[8] = i)),
      i
    );
  }
  let f;
  t[9] === u
    ? (f = t[10])
    : ((f = (e) => {
        (e.preventDefault(), u());
      }),
      (t[9] = u),
      (t[10] = f));
  let p;
  t[11] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((p = (e) => c(e.target.value.replace(/[^\d+ ]/g, ``))), (t[11] = p))
    : (p = t[11]);
  let m;
  t[12] === s
    ? (m = t[13])
    : ((m = (
        <label
          className={`flex min-w-48 flex-1 flex-col gap-1 text-xs text-(--text)`}
          children={[
            `Número del teléfono del bot`,
            <input
              className={`${Lo} min-h-11`}
              inputMode={`tel`}
              placeholder={`987 654 321`}
              value={s}
              maxLength={20}
              onChange={p}
            />,
          ]}
        />
      )),
      (t[12] = s),
      (t[13] = m));
  let h;
  if (t[14] !== s) {
    let e;
    (t[16] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((e = /\D/g), (t[16] = e))
      : (e = t[16]),
      (h = s.replace(e, ``)),
      (t[14] = s),
      (t[15] = h));
  } else h = t[15];
  let _ = h.length < 9,
    v;
  t[17] !== u || t[18] !== _
    ? ((v = (
        <AccionAsync
          className={`min-h-11`}
          disabled={_}
          onClick={u}
          children={`Pedir código`}
        />
      )),
      (t[17] = u),
      (t[18] = _),
      (t[19] = v))
    : (v = t[19]);
  let y;
  return (
    t[20] !== f || t[21] !== m || t[22] !== v
      ? ((y = (
          <form
            className={`flex flex-wrap items-end gap-2`}
            onSubmit={f}
            children={[m, v]}
          />
        )),
        (t[20] = f),
        (t[21] = m),
        (t[22] = v),
        (t[23] = y))
      : (y = t[23]),
    y
  );
}
